__webpack_require__.p = "/assets/turbo/68bd6da4/quellede/_next/";